import { combineReducers } from 'redux';

// Import custom components
import productReducer from './products';
import cartReducer from './cart';
import wishlistReducer from './wishlist';
import compareReducer from './compare';
import filterReducer from './filter';
import modalReducer from './modal';
import authReducer from '../components/pages/AuthContainer/auth.reducer'
import toastReducer from '../components/pages/AuthContainer/rootLayout.reducer'

const rootReducer = combineReducers( {
    data: productReducer,
    cartlist: cartReducer,
    wishlist: wishlistReducer,
    compare: compareReducer,
    filters: filterReducer,
    modal: modalReducer,
    toast: toastReducer,
    auth: authReducer
} );

export default rootReducer;